export default {
    ARROW_SIZE: 48,
    VIEWBOX_WIDTH: 24,
    VIEWBOX_HEIGHT: 40
};
